import { Space, Badge } from 'antd';
import { useRequest } from 'ahooks';
import { useTranslate } from '@tolgee/react';
import { getQuestionCount } from 'views/Mercado/FAQ/services';
import { eventBus } from 'services/eventBus';

export const MercadoNav = () => {
  const { t } = useTranslate();
  const { data } = useRequest(
    () => {
      eventBus.emit('MERCADO_QA_EVENT', 'refresh');
      return getQuestionCount();
    },
    {
      pollingInterval: 60 * 1000,
      pollingWhenHidden: false,
    },
  );

  return (
    <Space>
      {t('scene.workspace.title.faq')}
      <Badge style={{ background: '#17C2FF' }} count={data} overflowCount={9999} />
    </Space>
  );
};
